/**
 * Languages API — fetches from backend for autocomplete.
 */

import { apiFetch } from './fetch';
import { API } from '../constants';
import type { Language } from '../types/dvms.types';

export interface BackendLanguageResponse {
    id: string;
    languageName: string;
    isoCode: string;
    isActive: boolean;
}

/** Fetch all languages from the backend. */
export async function fetchLanguages(): Promise<BackendLanguageResponse[]> {
    const result = await apiFetch<{ data: BackendLanguageResponse[] | null | undefined } | BackendLanguageResponse[]>(
        `${API.LANGUAGES}?page=0&limit=200`,
    );
    if (Array.isArray(result)) {
        return result;
    }
    return result.data ?? [];
}

/** Search languages by name or ISO code. Empty query returns the 10 most recent. */
export async function searchLanguages(query: string, signal?: AbortSignal): Promise<Language[]> {
    const opts: RequestInit = {};
    if (signal) {
        opts.signal = signal;
    }
    const result = await apiFetch<{ id: string; languageName: string; isoCode: string }[]>(
        `${API.LANGUAGES}/search?filter=${encodeURIComponent(query)}`,
        opts,
    );
    if (!Array.isArray(result)) {
        return [];
    }
    return result.map((r) => ({ id: r.id, name: r.languageName, code: r.isoCode }));
}
